export const CLASSTING_API_URL = process.env.REACT_APP_API_URL
export const CLASSTING_OPEN_API_URL = process.env.REACT_APP_OPEN_API_URL
export const CLASSTING_AD_API_URL = process.env.REACT_APP_AD_API_URL
export const CLASSTING_PAY_API_URL = process.env.REACT_APP_PAY_API_URL
export const CLASSTING_AD_ADMIN_URL = process.env.REACT_APP_AD_ADMIN_URL
